<script setup lang="ts">
import {Steppy} from 'vue3-steppy'
import {getCurrentInstance, ref, watch} from "vue";
import DetailsHeadingBloc from "@/views/booking/components/DetailsHeadingBloc.vue";
import NewCustormer from "@/views/booking/components/NewCustormer.vue";
import OldCustomer from "@/views/booking/components/OldCustomer.vue";
import StayStep from "@/views/booking/components/StayStep.vue";
import BookingResume from "@/views/booking/components/BookingResume.vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Stay from "@/models/Stay";
import Customer from "@/models/Customer";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const step = ref(1)
const router = useRouter()
const backTitle = "Précédent";
const nextTitle = "Suivant";
const color = "#D62F2F";
const sizeCircle = 58;
const doneTitle = "Réserver";
const store = useStore()
const stepTitle = ref([
  {
    title: 'Enregistrement',
    iconSuccess: null,
    isValid: true
  },
  {
    title: 'Séjours',
    iconSuccess: null,
    isValid: true
  },
  {
    title: 'Resumé',
    iconSuccess: null,
    isValid: true
  }
]);
const isNewCustomer = ref(store.getters['booking/getIsNewCustomer']);
const load = ref(false);
watch(step, async (newStep) =>{
  if (newStep == 2 && store.getters["booking/getCustomer"] === null){
    step.value = 1
    $alert.fire({
      title: 'Ooops!',
      text: "Veuillez renseigné vos infos si vous nouveau ou entré votre contact si vous êtes déjà enregistré",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }else if (newStep == 3 && store.getters["booking/getStay"] === null){
    step.value = 2
    $alert.fire({
      title: 'Ooops!',
      text: "Veuillez renseigné les infos du séjours",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }
})
const oldCustomerFound = ()=>{
  step.value = 2
}
const newCustomerFound = ()=>{
  step.value = 2
}
const stayInfosSet= ()=>{
  step.value = 3
}
function  saveBooking(){
  load.value = true
  const stay:Stay = store.getters['booking/getStay']
  const customer:Customer =store.getters['booking/getCustomer']
  const isNewCustomer:boolean  = store.getters['booking/getIsNewCustomer']
  const customerBookData = {
    stay_data:stay,
    customer_data:customer,
    isNew:isNewCustomer,
    custId: isNewCustomer? null:customer.id
  }
$axios.post($endpoint.CreateBooking, customerBookData).then((resp_book:any) => {
  $alert.fire({
    title: 'Opération réussie !',
    text: resp_book.data.message,
    icon: 'success',
    confirmButtonColor:'#D62F2F',
    confirmButtonText: 'OK'
  })

  store.dispatch('booking/resetCustomer')
  store.dispatch('booking/resetStay')
  store.dispatch('room/resetRoomChoose')
  store.dispatch('booking_filter/resetRoomFilterData')
  setTimeout(()=>{
    load.value =false
  },1000)
  router.push('/apartments')
}).catch((err:any)=>{
  console.warn(err)
})
}
const cancelBooking = ()=>{
  store.dispatch('booking/resetCustomer')
  store.dispatch('booking/resetStay')
  store.dispatch('room_data/resetRoomFilterData')
  store.dispatch('booking_filter/resetRoomFilterData')
  router.go(-1)
}
</script>

<template>
  <loading-spinner v-if="load"></loading-spinner>

  <DetailsHeadingBloc title="Reservation de l'appart choisir" sub-tile="Procéder à l'enregistrement de votre reservation" />

  <div class="uk-container mt-10">
    <button class="uk-button uk-button-default csa-btn uk-width-1-4@l uk-width-1-2@s uk-width-1-2@m uk-margin-large-top" @click="cancelBooking()">Annuler la reservation</button>

    <Steppy v-model:step="step" v-model:tabs="stepTitle"
            v-model:finalize="saveBooking"
            v-model:backText="backTitle"
            v-model:nextText="nextTitle"
            v-model:doneText="doneTitle"
            v-model:primaryColor1="color"
            v-model:circleSize="sizeCircle"
    >
      <template #1 >
        <div class="uk-flex uk-flex-column uk-flex-center">
          <h4 >Merci de choisir la méthode d'enregistrement.</h4>
          <div>
            <button class="uk-button uk-button-default csa-btn" @click="isNewCustomer = true">S'enregistrer <i v-if="isNewCustomer" class="fa fa-check-circle"></i></button>
            <button class="uk-button uk-button-default csa-btn" @click="isNewCustomer = false">Déjà enregistré <i v-if="!isNewCustomer" class="fa fa-check-circle"></i></button>
          </div>
          <new-custormer v-if="isNewCustomer" @customer-save="newCustomerFound()"></new-custormer>
          <old-customer @customer-found="oldCustomerFound()" v-if="!isNewCustomer"></old-customer>
        </div>
      </template>
      <template #2>
        <stay-step @stay-infos-save="stayInfosSet()"></stay-step>
      </template>
      <template #3>
        <booking-resume></booking-resume>
      </template>
    </Steppy>
  </div>
</template>

<style scoped>
.mt-10{
  position: relative;
  margin-top: 10rem;
}

</style>